module.exports = __webpack_public_path__ + "static/media/IconLogo.13dfc037.png";